import { type ReactNode, type JSX, useState, useEffect } from 'react';
import { ToastContext } from './utils/use-toast';
import ToastContainer, { type ToastProperties } from '@/common/components/ToastContainer';

export const ToastProvider = ({ children }: { readonly children: ReactNode }): JSX.Element => {
  const [toast, setToast] = useState<ToastProperties>();

  const showToast = (value: ToastProperties): void => {
    setToast(value);
  };

  useEffect(() => {
    let timeoutId: number | undefined;

    if (toast) {
      timeoutId = globalThis.window.setTimeout(() => {
        setToast(undefined);
      }, 5000);
    }

    return () => {
      if (timeoutId !== undefined) {
        globalThis.window.clearTimeout(timeoutId);
      }
    };
  }, [toast]);

  return (
    <ToastContext value={showToast}>
      {children}
      {toast && <ToastContainer {...toast} />}
    </ToastContext>
  );
};
